<!--
 * @Author: DQL
 * @Date: 2022-04-28 11:18:16
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:39:08
 * @Description: 项目管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        项目管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          v-if="addBtnShow"
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="openNavTab({ name: 'addJcxm'})"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
                prop="wtdw"
              >
                <el-input
                  v-model.trim="filterParams.wtdw"
                  class="c-form__input"
                  placeholder="请输入委托单位"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属账号"
                prop="sszh"
              >
                <el-input
                  v-model.trim="filterParams.sszh"
                  class="c-form__input"
                  placeholder="请输入所属账号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="状 态"
                prop="ztDm"
              >
                <el-select
                  v-model="filterParams.ztDm"
                  class="c-form__select"
                  placeholder="请选择状态"
                  clearable
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="(item,index) in xmType"
                    :key="index"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--search__body">
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openNavTab({ name: 'viewXfjc', params: { xmId: scope.row.xmId } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #bgbh="scope">
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <template #jcjl="scope">
              <span
                class="c-form__read"
              >
                {{ scope.row.jcjl =='Y'?'合格': scope.row.jcjl =='N'?'不合格':'/' }}
              </span>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="170"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  v-if="scope.row.xmzt === 'YQZ' || scope.row.xmzt === 'YGZ' || scope.row.xmzt === 'DGZ' "
                  v-permission-element="'jcxm_sqxg'"
                  btn-text="申请修改"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleSqxg(scope.row)"
                />
                <k-button
                  v-if="scope.row.xmzt === 'WKS' || scope.row.xmzt === 'DSC' || scope.row.xmzt === 'ZXZ' "
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'editJcxm', params: { xmId: scope.row.xmId } })"
                />
                <k-button
                  v-if="scope.row.zybz === '1' && (scope.row.xmzt === 'WKS' || scope.row.xmzt === 'DSC' || scope.row.xmzt === 'ZXZ')"
                  btn-text="转移"
                  :auth-type="true"
                  type="success"
                  plain
                  @click="handleDialog('translate', scope.row)"
                />
                <k-button
                  v-if="scope.row.kscbz === 'Y' && !scope.row.bgbh"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  plain
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        已出过报告的项目不可删除
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 项目转移 -->
    <jc-translate-dialog
      v-if="showDialogName==='translate'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { xmglService } from './xmgl.service';
import JcTranslateDialog from './translate.vue';

export default {
  name: 'JcxmIndex',
  components: {
    JcTranslateDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      addBtnShow: false, // 新增按钮显示
      delBtnShow: false, // 删除按钮显示标志

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        ztDm: [], // 状态
        // cjsjQz: [null, null], // 创建时间起止
        // cjsjq: null, // 创建时间起
        // cjsjz: null, // 创建时间止
        sszh: null,
        xmmc: null, // 项目名称
        wtdw: null // 委托单位
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '200', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '180', type: 'text' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jcjl', slotName: 'jcjl', label: '检测结论', align: 'left', minWidth: '100', type: 'text' },
        { key: 'sszhMc', label: '所属账号', align: 'left', width: '80', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', width: '130', type: 'dateTime' },
        { key: 'xmztMc', label: '当前状态', align: 'center', width: '100', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 End */

      pageParams: {}

    };
  },
  computed: {
    xmType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JCXM_STATUS) {
        return enums.IFF_JCXM_STATUS;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      xmglService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 申请修改
     * @return {*}
     */
    handleSqxg (_row) {
      const _this = this;
      _this.$confirm('是否确认申请修改此检测项目数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.sqxg(_row.id)
          .then(rsp => {
            _this.$alert('已成功提交申请！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('申请失败', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此检测项目：${_row.xmmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.delete(_row.xmId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 作废
     * @return {*}
     * @param {*} _row
     */
    handleZf (_row) {
      const _this = this;
      _this.$confirm(`是否确认作废此检测项目：${_row.xmmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.delete(_row.id)
          .then(rsp => {
            _this.$alert('作废成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('作废失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出数据
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      xmglService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
    if (this.$route.meta.navtabTitle === '项目管理') {
      this.addBtnShow = true;
      this.delBtnShow = true;
    }
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>

<style scoped lang="scss">
  .o-tips {
    position: absolute;
    top: 4px;
    right: 12px;
    z-index: 9;
    padding-left: 8px;
    border-left: 0;
    color: #f56c6c;
    background-color: #fef0f0;
  }
</style>
